module.exports = __webpack_public_path__ + "img/banner-company-img-sp.49aff91b.svg";